import { combineSlices } from '@reduxjs/toolkit';
import { modalsSlice } from './modals/modalsSlice';
import { errorsSlice } from './errors/errorsSlice';
import { plaidSlice } from './plaid/plaidSlice';
import { userSlice } from './user/userSlice';
import { surveySlice } from './survey/surveySlice';
import { collectionSlice } from './collection/collectionSlice';

const rootReducer = combineSlices(
  modalsSlice,
  plaidSlice,
  surveySlice,
  userSlice,
  errorsSlice,
  collectionSlice,
);

export default rootReducer;
